import { render, staticRenderFns } from "./AppSidebar.vue?vue&type=template&id=a4be2c34&scoped=true"
import script from "./AppSidebar.vue?vue&type=script&lang=js"
export * from "./AppSidebar.vue?vue&type=script&lang=js"
import style0 from "./AppSidebar.vue?vue&type=style&index=0&id=a4be2c34&prod&lang=scss&scoped=true"
import style1 from "./AppSidebar.vue?vue&type=style&index=1&id=a4be2c34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4be2c34",
  null
  
)

export default component.exports